import { render, staticRenderFns } from "./combofund.vue?vue&type=template&id=4c967994&scoped=true"
import script from "./combofund.vue?vue&type=script&lang=js"
export * from "./combofund.vue?vue&type=script&lang=js"
import style0 from "./combofund.vue?vue&type=style&index=0&id=4c967994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c967994",
  null
  
)

export default component.exports